<template>
  <picker-field
    :label="label"
    :clockDate="clockDate"
    :value="value"
    ref="picker"
    @open="onSearch"
  >
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{ item }}</p>
          </div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField,
  },
  props: {
    label: {
      type: String,
      default: "时段",
    },
    value: String,
    clockDate: String
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      if (me.clockDate) {
        me.$loading({
          url: "/api/hr/checkinRule/getCheckInTimeByEmid?date=" + me.dateFormat(me.clockDate, "yyyy-MM-dd"),
        }).then(function (res) {
          if (res.success) {
            me.items = res.data;
          } else {
            me.$weui.topTips(res.message, 2000);
          }
        });
      } else {
        me.$weui.topTips("请先选择补卡时间", 2000);
      }
    },
  },
};
</script>